export default [
  {
    path: '/apps/tipo-pedido/list',
    name: 'apps-tipo-pedido-list',
    component: () => import('@/views/cadastros-gerais/tipo-pedido/list/Index.vue'),
    meta: {
      pageTitle: 'Tipo Pedido',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/cliente-tipo-pedido/edit/:id',
  //     name: 'apps-cliente-tipo-pedido-edit',
  //     component: () => import('@/views/cadastros-gerais/cliente-tipo-pedido/cliente-tipo-pedido-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Familia Comercial',
  //         resource: 'AdminHanes',
  //     },
  // },
];
